<template>
  <div>
    <modal-seminar-download />
    <div class="d-flex justify-content-between align-items-center mb-32">
      <h3 v-if="isSeminarMode" class="m-0">Документы для загрузки</h3>
      <a href="#" @click.prevent="getTemplate()" class="docs-needed d-none d-md-block d-lg-block">
        Скачать шаблон направления
      </a>
    </div>
    <a href="#" @click.prevent="getTemplate()" class="docs-needed d-lg-none">
      Скачать шаблон направления
    </a>
    <base-upload :required="!isLecture || requiresAgreement" id="scan_trip_education" name="scan_trip_education" title="Направление на семинар Школы экспорта РЭЦ" description="Для иностранных обучающихся – перевод документов, оформленный в установленном порядке" v-model="docs.scan_trip_education" />
    <base-upload :required="false" id="scan_proxy" name="scan_proxy" title="Доверенность" description="Приложите доверенность на лицо, подписавшее направление на обучение, если данное лицо не является руководителем организации" v-model="docs.scan_proxy" />
    <base-upload v-if="isLecture" :required="false" id="scan_change_surname" name="scan_change_surname" title="Свидетельство о смене фамилии" description="Копия свидетельства о смене фамилии (при необходимости)" v-model="docs.scan_change_surname" />
    <base-upload v-if="requiresAgreement" :required="true" id="agreement" name="agreement" title="Согласие на обработку персональных данных" description="Подписанное согласие на обработку персональных данных" :sample="{title: 'Скачать образец согласия', link: 'https://exporteduru.servicecdn.ru/media/default/0003/53/06525322d5311a9722a1c61aeb4db92e0216fbf7.docx'}" v-model="docs.agreement" />
  </div>
</template>

<script>
import BaseUpload from "@/components/form/BaseUpload.vue";
import ApiService from "../../services/api.service";
import EventOrder from "@/views/EventOrder.vue";
import ModalSeminarDownload from "@/components/ModalSeminarDownload.vue";
import $ from "jquery";
import {TokenService} from "../../services/token.service";

export default {
  name: "SeminarOrderDocs",
  components: {ModalSeminarDownload, BaseUpload},
  extends: {EventOrder},
  props: ['value', 'isSeminarMode', 'program', 'eventType'],
  async mounted() {
    this.docs = (await ApiService.get('userdocs/' + this.$route.params.id + '/event')).data
    this.firstLoad = false
  },
  data() {
    return {
      firstLoad: true,
      token: TokenService
          .getToken()
          .replaceAll('"', ''),
      docs: {
        scan_proxy: null,
        scan_trip_education: null,
        scan_change_surname: null
      }
    }
  },
  methods: {
    getMedia(val, field) {
      return val[field] ? val[field].id : null
    },
    async getTemplate() {
      if(this.errors.items.length > 1) {
        $('#seminar-download-doc').modal('show');
      } else {
        await this.$parent.$parent.draft()
        window.open(ApiService.baseURL() + 'api/document/template?access_token=' + this.token + '&program=' + this.program, '_blank')
      }
    }
  },
  computed: {
    isLecture() {
      return this.eventType === 'lecture'
    },
    requiresAgreement() {
      return Number(this.program) === 58
    }
  },
  watch: {
    docs: {
      handler: function(val) {
        if(val.id && !this.firstLoad) {
          this.$emit('input', val)
          ApiService.put('userdocs/' + val.id, {
            scan_trip_education: this.getMedia(val, 'scan_trip_education'),
            scan_proxy: this.getMedia(val, 'scan_proxy'),
            scan_change_surname: this.getMedia(val, 'scan_change_surname'),
            agreement: this.getMedia(val, 'agreement'),
          })
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="scss">
@import "./src/assets/style/variables";
.docs-needed {
  color: $blue-03;
  text-decoration: underline;
  position: relative;
  padding-right: 3.4rem;
  &:hover {
    text-decoration: none;
  }
  &:after {
    display: block;
    width: 2.4rem;
    height: 2.4rem;
    position: absolute;
    right: 0;
    content: "";
    top: 0;
    @media (max-width: 768px) {
      width: 24px;
      height: 24px;
      right: -12px;
    }
    background: url("/pic/profile/arrow-up-right.svg");
  }
}
</style>